import { ArcOverlayBackdrop } from './ArcOverlayBackdrop.js';
export { ArcOverlayBackdrop };
window.customElements.define('arc-overlay-backdrop', ArcOverlayBackdrop);
